import {type DiscordSDK} from '@discord/embedded-app-sdk'
import {type DiscordEvent} from '../../../../../../shared/DiscordActivityTypes.ts'
import {DiscordMountContentFrameDispatcher} from '../dispatchers/DiscordMountContentFrameDispatcher.ts'

export class DiscordMountSDKEventListener {
    private readonly discordSDK: DiscordSDK
    private readonly subscriptions: Set<DiscordEvent> = new Set<DiscordEvent>()

    constructor(discordSDK: DiscordSDK) {
        this.discordSDK = discordSDK
    }

    subscribe(event: DiscordEvent | undefined) {
        if(event == undefined) throw new Error('Event is missing')
        if(this.subscriptions.has(event)) return

        void this.discordSDK.subscribe(event, (eventData) => {
            DiscordMountContentFrameDispatcher.notifyWhenDiscordEventTriggers(event, eventData)
        })

        this.subscriptions.add(event)
    }

    unsubscribe(event: DiscordEvent | undefined) {
        if(event == undefined) throw new Error('Event is missing')
        if(!this.subscriptions.has(event)) return

        void this.discordSDK.unsubscribe(event, (eventData) => {
            DiscordMountContentFrameDispatcher.notifyWhenDiscordEventTriggers(event, eventData)
        })

        this.subscriptions.delete(event)
    }
}
